import React from 'react';
import { Droplets, Sparkles, Leaf } from 'lucide-react';
export function FeaturesGrid() {
  return <section className="py-20 px-6 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        
        {/* Encabezado de la Sección */}
        <div className="text-center mb-16" data-id="element-3">
          <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-xs font-bold mb-3 block" data-id="element-4">
            Beneficios Reales y Comprobados
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-gray-900 mb-6" data-id="element-5">
            ¿Por qué el Yoga Facial es tu mejor secreto?
          </h2>
          <div className="w-24 h-1 bg-[#FADADD] mx-auto rounded-full" data-id="element-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-7">
          
          {/* Feature 1 */}
          <div className="flex flex-col items-center text-center group" data-id="element-8">
            <div className="w-20 h-20 rounded-full bg-[#FFFDD0] flex items-center justify-center mb-6 group-hover:bg-[#FADADD] transition-colors duration-500 shadow-sm" data-id="element-9">
              <Droplets className="w-8 h-8 text-gray-800" strokeWidth={1.5} data-id="element-10" />
            </div>
            <h3 className="text-xl font-heading font-medium text-gray-900 mb-4" data-id="element-11">
              1. Adiós "Puffy Face"
            </h3>
            <p className="text-gray-600 leading-relaxed font-light" data-id="element-12">
              Activa el drenaje linfático profundo para eliminar líquidos retenidos, borrar las ojeras y despedirte de la cara hinchada cada mañana.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="flex flex-col items-center text-center group" data-id="element-13">
            <div className="w-20 h-20 rounded-full bg-[#FFFDD0] flex items-center justify-center mb-6 group-hover:bg-[#FADADD] transition-colors duration-500 shadow-sm" data-id="element-14">
              <Sparkles className="w-8 h-8 text-gray-800" strokeWidth={1.5} data-id="element-15" />
            </div>
            <h3 className="text-xl font-heading font-medium text-gray-900 mb-4" data-id="element-16">
              2. Efecto Lifting Natural
            </h3>
            <p className="text-gray-600 leading-relaxed font-light" data-id="element-17">
              Tu rostro tiene más de 50 músculos. Aprende a tonificarlos para levantar pómulos caídos y marcar la línea de la mandíbula (Jawline).
            </p>
          </div>

          {/* Feature 3 */}
          <div className="flex flex-col items-center text-center group" data-id="element-18">
            <div className="w-20 h-20 rounded-full bg-[#FFFDD0] flex items-center justify-center mb-6 group-hover:bg-[#FADADD] transition-colors duration-500 shadow-sm" data-id="element-19">
              <Leaf className="w-8 h-8 text-gray-800" strokeWidth={1.5} data-id="element-20" />
            </div>
            <h3 className="text-xl font-heading font-medium text-gray-900 mb-4" data-id="element-21">
              3. Resultados Duraderos
            </h3>
            <p className="text-gray-600 leading-relaxed font-light" data-id="element-22">
              Olvídate de los costosos retoques, agujas y químicos. Una alternativa 100% natural donde inviertes una vez y los resultados te acompañan siempre.
            </p>
          </div>
          
        </div>
      </div>
    </section>;
}